/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'moment-timezone'
],
  function specialBuyTeaser(
    $,
    moment
  ) {
    var helperMethods = {
      calculateTimeLeft: function calculateTimeLeft(timeToExpiration) {
        if (typeof timeToExpiration !== 'number' || timeToExpiration <= 0) {
          return "0hr 00min 00sec"
        }
       var tempTime = moment.duration(timeToExpiration)
       var hours = tempTime.hours();
       var minutes = tempTime.minutes();
       if(minutes < 10) {
         minutes = "0" + minutes;
       }
       var seconds = tempTime.seconds();
       if(seconds < 10) {
         seconds = "0" + seconds;
       }
       var teaserMessage = hours + "hr " + minutes + "min " + seconds + "sec";
       return teaserMessage;
      },
      setTimeUntilDealEnd: function setTimeUntilDealEnd() {
        viewModel.timeUntilDealEnds = moment().tz('America/Anchorage').hour(23).minute(0).second(0);
      },
      getCurrentTime: function getCurrentTime() {
        var currentTime = moment();
        return currentTime;
      }
    };


    var view = {
      templates: {
      },

      selectors: {
        countDownTimer: '.SBOTD_timer',
      },

      render: {
      },

      updateDOM: {
        setTimer: function setTimer() {
          var currentTime = helperMethods.getCurrentTime();
          var timeToExpiration = viewModel.timeUntilDealEnds - currentTime;
          var timeLeft = helperMethods.calculateTimeLeft(timeToExpiration);
          var sbotdTeaserMessage = "Special Buy ends in " + timeLeft;
          $(view.selectors.countDownTimer).html(sbotdTeaserMessage);
        },
      }
    };

    var viewModel = {
      timeUntilDealEnds: 0,
      setSpecialBuyTime: function specialBuyTime() {
        var timer = setInterval(view.updateDOM.setTimer, 1000)
        return timer;
      }
    };

    var model = {

    };

    return {
      init: function specialBuyTeaserInit() {
        var specialBuy = $('.SBOTD_timer');
        if (specialBuy.length) {
          helperMethods.setTimeUntilDealEnd();
          viewModel.setSpecialBuyTime();
        }
      },
      view: view,
      viewModel: viewModel,
      model: model,
      helperMethods: helperMethods
    }
  });

}.call(window));